import { Box, makeStyles, styled } from "@material-ui/core";

export const useStyles = makeStyles(theme => ({
  boxAlign: {
    display: "flex",
    alignItems: "center",
    gap: "1rem",
    [theme.breakpoints.down("lg")]: {
      flexWrap: "wrap",
      gap: "0.8rem"
    },
    [theme.breakpoints.down("md")]: {
      flexDirection: "row",
      alignItems: "center",
      gap: "0.5rem"
    }
  },
  input: {
    width: "30rem",
    height: "3.9rem",
    marginTop: "1rem",
    [theme.breakpoints.down("lg")]: {
      width: "40%"
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginTop: "0.5rem"
    },
    [theme.breakpoints.between(0, 700)]: {
      marginLeft: 0
    }
  },
  dateField: {
    width: "12rem",
    height: "3.5rem",
    marginLeft: "1rem",
    border: "1px solid #C4C4C4",
    backgroundColor: "#FFFFFF",
    "& .MuiInputBase-root": {
      height: "100%",
      "&.Mui-focused": {
        boxShadow: `0 0 0 1px ${theme.palette.primary.dark}`
      }
    },
    "& .MuiInputBase-input": {
      padding: "14px 16px",
      fontSize: "0.95rem",
      color: "#333333",
      "&::placeholder": {
        color: "#999999",
        opacity: 1
      }
    },
    "& .MuiIconButton-root": {
      background: "#F5F5F5",
      borderRadius: "6px",
      color: "#666666",
      margin: "4px",
      "&:hover": {
        background: "#E5ECD1",
        color: "#587916"
      }
    },
    "& .MuiInputAdornment-root": {
      marginRight: "8px"
    },
    "& .MuiInput-underline": {
      "&:before": {
        borderBottom: "none"
      },
      "&:after": {
        borderBottom: "none"
      },
      "&:hover:not(.Mui-disabled):before": {
        borderBottom: "none"
      }
    },
    [theme.breakpoints.down("md")]: {
      width: "100%",
      marginTop: "0.5rem",
      marginLeft: "0"
    }
  },
  filterText: {
    fontFamily: "Roboto",
    fontWeight: 500,
    fontSize: "1.1rem",
    color: "#757575",
    marginLeft: "2rem",
    [theme.breakpoints.down("lg")]: {
      marginLeft: "1rem",
      fontSize: "1rem"
    },
    [theme.breakpoints.down("md")]: {
      marginLeft: "0",
      fontSize: "1rem"
    }
  },
  boxItemPopover: {
    width: "10rem",
    height: "3rem",
    textAlign: "center",
    padding: "0.5rem",
    "&:hover": {
      cursor: "pointer",
      background: "#F4F4F4"
    },
    [theme.breakpoints.down("md")]: {
      width: "8rem",
      height: "2.5rem"
    }
  },
  listItemText: {
    fontSize: "1.1rem",
    fontFamily: "Roboto",
    fontWeight: 500,
    lineHeight: "0.9rem",
    [theme.breakpoints.down("md")]: {
      fontSize: "1rem"
    }
  }
}));

export const BoxPaginateContent = styled(Box)({
  display: "flex",
  justifyContent: "center",
  paddingBlock: "1rem",
  "@media (max-width: 768px)": {
    paddingBlock: "0.5rem"
  }
});
